import React, { useRef, useState } from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';
import { Theme } from '@quillbot/design-system';
import { makeStyles } from '@mui/styles';
import HeroSection from './HeroSection';
import ProductsAdvantage from './ProductsAdvantage';
import Universities from './Universities';
import ThesisCourse from './ThesisCourse';
import Testimonials from './Testimonials';

const useStyles = makeStyles((theme: Theme) => ({}));

export default function StudentResources() {
  const [activeTab, setActiveTab] = React.useState('Paraphraser');
  const tabsWrapper = useRef<HTMLDivElement>(null);

  const platform = useSelector((rootState: RootState) => rootState?.common?.platform);

  const productBtnClick = (e: React.MouseEvent, tabName: string) => {
    if (platform.isIE) {
      window.scrollTo(0, Number(tabsWrapper.current?.offsetTop));
    } else {
      window.scrollTo({
        top: tabsWrapper.current?.offsetTop,
        behavior: 'smooth',
      });
    }
    setActiveTab(tabName);
  };

  return (
    <>
      <HeroSection clickHandler={(e, tabName) => productBtnClick(e, tabName)} />
      <Universities />
      <Testimonials />
      <div ref={tabsWrapper}>
        <ProductsAdvantage selectTab={activeTab} />
      </div>
      <ThesisCourse />
    </>
  );
}
